import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Domingo a la noche buscando un texto que nunca queda como querés', 'Clases improvisadas porque no tenés actividades listas y secuenciadas', 'Alumnos que no leen, no escriben y no participan por materiales aburridos', 'Horas perdidas en Google buscando ejercicios de ortografía, gramática o comprensión lectora', 'Planificaciones que hacés de apuro y que el directivo igual te devuelve'];
  return <section className="py-16 bg-amber-50" data-id="element-128">
      <div className="max-w-3xl mx-auto px-4" data-id="element-129">
        <h2 className="text-2xl md:text-3xl font-bold text-stone-900 mb-8 text-center" data-id="element-130">
          Si sos docente de Lengua en primaria o secundaria, esto te va a sonar
          familiar:
        </h2>

        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-10 border border-amber-200" data-id="element-131">
          <ul className="space-y-6" data-id="element-132">
            {points.map((point, i) => <li key={i} className="flex items-start gap-4" data-id="element-133">
                <XCircle className="w-6 h-6 text-rose-800 flex-shrink-0 mt-1" data-id="element-134" />
                <span className="text-lg text-stone-700 font-medium" data-id="element-135">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>

        <p className="text-xl md:text-2xl font-bold text-center text-rose-900 mt-10" data-id="element-136">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>
      </div>
    </section>;
}